module.exports = __webpack_public_path__ + "img/phone.2f2ab8e4.svg";